class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static freeShippingText = window.free_shipping_text.free_shipping_message;
    static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
    static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
    static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
    static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
    static classLabel1 = 'progress-30';
    static freeshipPrice = parseInt(window.free_shipping_price);

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.shipVal = window.free_shipping_text.free_shipping_1;
        this.progressMeter = this.querySelector('[ data-free-shipping-progress-meter]');
        this.disclaimerElement = this.querySelector('[data-free-shipping-disclaimer]');

        this.addEventListener('change', this.onCartChange.bind(this));

        this.observeCartTotal();
        this.initialize();
    }

    disconnectedCallback() {
        this.totalObserver?.disconnect();
    }

    // Bundler rewrites the cart total text after the theme renders it, so recalculate whenever it changes
    observeCartTotal() {
        const totalElement = this.getCartTotalElement();
        if (!totalElement) return;

        this.totalObserver = new MutationObserver(() => {
            if (this.cart) this.calculateProgress(this.cart);
        });
        this.totalObserver.observe(totalElement, { childList: true, subtree: true, characterData: true });
    }

    // Find the [data-cart-total-value] belonging to the same cart (side cart or cart page) as this meter
    getCartTotalElement() {
        let parent = this.parentElement;
        while (parent) {
            const totalElement = parent.querySelector('[data-cart-total-value]');
            if (totalElement) return totalElement;
            parent = parent.parentElement;
        }
        return null;
    }

    // Total in dollars, preferring the price shown on the page (Bundler discount applied) over cart.js
    getCartTotal(cart) {
        const cartJsTotal = parseInt(cart.total_price) / 100;
        const totalElement = this.getCartTotalElement();
        if (!totalElement || cart.item_count === 0) return cartJsTotal;

        // Bundler may show a struck-through original next to the new price, so take the lowest amount shown
        const amounts = (totalElement.textContent.match(/\d[\d,]*(?:\.\d{1,2})?/g) || [])
            .map((amount) => parseFloat(amount.replace(/,/g, '')))
            .filter((amount) => !isNaN(amount));

        return amounts.length ? Math.min(...amounts) : cartJsTotal;
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        })
    }

    onCartChange(e) {
        this.initialize();
    }

    calculateProgress(cart) {
        // Check if cart has any non-goodbuyz vendor
        // non-goodbuyz vendor = Dropship Zone, Toys R Us, ABM
        const nonGoodBuyzVendors = ['Dropship Zone', 'Toys R Us', 'ABM'];
        const hasNonGoodBuyzVendor = cart.items.some((item) => nonGoodBuyzVendors.includes(item.vendor));
        this.disclaimerElement.style.display = hasNonGoodBuyzVendor ? 'none' : '';
        if (hasNonGoodBuyzVendor) {
            this.progressBar.classList.add('progress-hidden');
            this.messageElement.innerHTML = '';
            return;
        }

        const cartTotalPrice = this.getCartTotal(cart);
        const cartTotalPriceFormatted = cartTotalPrice.toFixed(2);
        const cartTotalPriceRounded = parseFloat(cartTotalPriceFormatted);

        // Floor, not round: e.g. $199.95 of $200 must stay below 100% so it isn't styled as free shipping
        let freeShipBar = Math.floor((cartTotalPriceRounded * 100) / FreeShippingMeter.freeshipPrice);
        if (cartTotalPriceRounded >= FreeShippingMeter.freeshipPrice) {
            freeShipBar = 100;
        } else if (freeShipBar >= 100) {
            freeShipBar = 99;
        }
        
        const text = this.getText(cartTotalPriceFormatted, freeShipBar);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getText(cartTotalPrice, freeShipBar) {
        let text;

        if (cartTotalPrice == 0) {
            this.progressBar.classList.add('progress-hidden');
            text = '<span>' + FreeShippingMeter.freeShippingText + ' ' + Shopify.formatMoney(FreeShippingMeter.freeshipPrice * 100, window.money_format) +'!</span>';
        } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            text = FreeShippingMeter.freeShippingText1;
        } else {
            this.progressBar.classList.remove('progress-hidden');
            const remainingPriceCents = Math.round((FreeShippingMeter.freeshipPrice - cartTotalPrice) * 100);
            text = '<span>' + FreeShippingMeter.freeShippingText2 + ' </span><strong>' + Shopify.formatMoney(remainingPriceCents, window.money_format) + '</strong><span> ' +  FreeShippingMeter.freeShippingText3 + ' </span><span class="text">' + FreeShippingMeter.freeShippingText4 + '</span>';
            this.shipVal = window.free_shipping_text.free_shipping_2;
        }

        return text;
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel1;
        } else {
            classLabel = 'progress-free'
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');

        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);

            this.progressMeter.style.width = `${freeShipBar}%`;
            if (this.textEnabled) {
                const textWrapper = this.progressMeter.querySelector('.text').innerHTML = `${freeShipBar}%`;
            }

            this.messageElement.innerHTML = text;

            if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }
        }, 400)
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
})